import { Button } from "primereact/button";
import { Message } from "primereact/message";
import { Tag } from "primereact/tag";

import { Icon } from "@/ds";
import { CampoDecimal } from "@/shared/components";
import { CotacaoDialog } from "../cotacao-dialog";
import { SolicitarCotacaoDialog } from "../solicitar-cotacao-dialog";
import { DESCARTAR_LABEL } from "./cotacao-card.constants";
import styles from "./cotacao-card.module.scss";
import type { CotacaoCardViewModel } from "./types-cotacao-card";

export function CotacaoCardView({
  modo,
  titulo,
  valor,
  nota,
  editarLabel,
  definirLabel,
  podeEditar,
  podeDefinir,
  solicitacao,
  salvarLabel,
  edicao,
  solicitarDialog,
  cotacaoDialog,
  editar,
  descartar,
  digitar,
  salvar,
  cancelarSolicitacao,
  definir,
}: CotacaoCardViewModel) {
  const pendente = modo === "pendente";
  const editarNaLinhaDoTitulo = modo === "consulta" && podeEditar;

  return (
    <>
      <form
        className={pendente ? styles.cotacaoPendente : styles.cotacao}
        data-editar-na-linha={editarNaLinhaDoTitulo || undefined}
        onSubmit={salvar}
        noValidate
        data-testid="planejamento-cotacao"
      >
        <Icon name="dollar" size={14} />
        <div className={styles.textos}>
          <span className={styles.titulo}>{titulo}</span>
          {valor && modo === "consulta" ? (
            <span className={styles.valorLinha}>
              <span className={styles.valor}>{valor}</span>
              {solicitacao ? (
                <Tag
                  value={solicitacao.tag}
                  severity="warning"
                  icon="pi pi-hourglass"
                  data-testid="planejamento-cotacao-em-aprovacao"
                />
              ) : null}
            </span>
          ) : null}
          {pendente && nota ? (
            <span className={styles.notaPendente} data-testid="planejamento-cotacao-nota">
              {nota}
            </span>
          ) : null}
        </div>

        {modo === "consulta" ? (
          <>
            <span className={styles.nota} data-testid="planejamento-cotacao-nota">
              {solicitacao ? solicitacao.texto : nota}
            </span>
            {solicitacao?.podeCancelar ? (
              <Button
                type="button"
                size="small"
                severity="secondary"
                outlined
                label={solicitacao.cancelarLabel}
                loading={solicitacao.cancelando}
                onClick={cancelarSolicitacao}
                data-testid="planejamento-cotacao-cancelar-solicitacao"
              />
            ) : null}
            {solicitacao?.erro ? (
              <Message
                className="p-message-block"
                severity="error"
                text={solicitacao.erro}
                data-testid="planejamento-cotacao-erro-cancelar"
              />
            ) : null}
            {podeEditar ? (
              <Button
                type="button"
                size="small"
                severity="secondary"
                outlined
                icon={<Icon name="pencil" size={14} />}
                label={editarLabel}
                className={styles.acaoTitulo}
                onClick={editar}
                data-testid="planejamento-cotacao-acao"
              />
            ) : null}
          </>
        ) : null}

        {modo === "edicao" ? (
          <>
            <span className={styles.moeda}>{edicao.moedaPrefixo}</span>
            <div className={styles.campo}>
              <CampoDecimal
                label={edicao.campoLabel}
                labelOculto
                casas={6}
                value={edicao.valor}
                onChange={digitar}
                error={edicao.erro}
                disabled={edicao.salvando}
                foco={edicao.foco}
                testId="planejamento-cotacao-campo"
              />
            </div>
            <span className={styles.nota} data-testid="planejamento-cotacao-referencia">
              {edicao.referencia}
            </span>
            <div className={styles.acoes}>
              <Button
                type="button"
                text
                severity="secondary"
                size="small"
                label={DESCARTAR_LABEL}
                onClick={descartar}
                disabled={edicao.salvando}
                data-testid="planejamento-cotacao-descartar"
              />
              <Button
                type="submit"
                size="small"
                label={salvarLabel}
                loading={edicao.salvando}
                data-testid="planejamento-cotacao-salvar"
              />
            </div>
            {edicao.erroSalvar ? (
              <Message
                className="p-message-block"
                severity="error"
                text={edicao.erroSalvar}
                data-testid="planejamento-cotacao-erro"
              />
            ) : null}
          </>
        ) : null}

        {pendente && podeDefinir ? (
          <Button
            type="button"
            size="small"
            label={definirLabel}
            onClick={definir}
            data-testid="planejamento-cotacao-acao"
          />
        ) : null}
      </form>
      {solicitarDialog ? <SolicitarCotacaoDialog {...solicitarDialog} /> : null}
      {cotacaoDialog ? <CotacaoDialog {...cotacaoDialog} /> : null}
    </>
  );
}
